import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.LOCATIONS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.LOCATIONS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.LOCATIONS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.LOCATIONS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.LOCATIONS_FILTER_BY, filterBy)
  },
  [types.SET_LOCATION_TREE](state, data) {
    state.locationTree = data
  },
  [types.SET_LOCATIONS](state, data) {
    state.locations = data
    console.log('Got Locations', state.locations)
  },
  [types.SET_LOCATION](state, data) {
    state.location = data
    console.log('Got Location', state.location)
  },
  [types.SET_CURRENT_LOCATION](state, data) {
    state.currentLocation = data
  },
  [types.PUSH_LOCATION](state, data) {
    state.locationTree.push(data)
    state.currentLocation = state.locationTree.slice(-1)[0]
  },
  [types.POP_LOCATION](state) {
    state.locationTree.pop()
    state.currentLocation = state.locationTree.slice(-1)[0]
  },
  [types.SET_LOCATIONS_FOUND](state, data) {
    state.locationsFound = []
    if (data !== undefined && data !== null) {
      state.locationsFound = data
    }
  },
  [types.RESET_PREFERENCES](state) {
    state.preferences = []
  },
  [types.SET_PREFERENCE](state, data) {
    state.preferences.forEach(element => {
      if (element.name === data.name && element.type === data.type) {
        element.firm = data.firm
        if (data.isInactive !== undefined && data.isInactive !== null) {
          element.isInactive = data.isInactive
        } else {
          element.value = data.value
        }
        element.changed = true
      }
    })
  },
  [types.RESET_PREFERENCE_CHANGE](state, element) {
    if (state.preferences !== undefined && state.preferences !== null) {
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          state.preferences[i].changed = false
        }
      }
    }
  },
  [types.UPDATE_PREFERENCE](state, data) {
    if (state.preferences.length === 0) {
      state.preferences = []
    }
    if (state.preferences !== undefined && state.preferences !== null) {
      let found = false
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          if (
            state.preferences[i].type === data.type &&
            parseInt(state.preferences[i].firm) === parseInt(data.firm)
          ) {
            if (state.preferences[i].name === data.name) {
              if (data.isInactive !== undefined && data.isInactive !== null) {
                state.preferences[i].isInactive = data.isInactive
              } else {
                state.preferences[i].value = data.value
              }
              state.preferences[i].changed = true
              found = true
              break
            }
          }
        }
      }
      if (found === false) {
        data.changed = true
        state.preferences.push(data)
      }
    }
  },
  [types.SET_PREFERENCES](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        if (Array.isArray(data)) {
          data.forEach(element => {
            element.changed = false
            let found = false
            for (var i = 0; i < state.preferences.length; i++) {
              if (
                state.preferences[i].name === element.name &&
                state.preferences[i].type === element.type
              ) {
                found = true
                break
              }
            }
            if (!found) {
              state.preferences.push(element)
            }
          })
        } else {
          state.preferences.push(data)
        }
        console.log('Got Preferences', state.preferences)
      }
    }
  },
  [types.RESET_EMAIL_TEMPLATE](state) {
    state.emailTemplate = null
  },
  [types.SET_EMAIL_TEMPLATE](state, data) {
    state.emailTemplate = data
  },
  [types.SET_DISPATCHED_TECHS](state, data) {
    state.dispatchedTechs = data
    console.log('Got Dispatched Techs', state.dispatchedTechs)
  },
  [types.UPDATE_EMAIL_TEMPLATE](state, data) {
    if (state.emailTemplate !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.emailTemplate.firm = data.value
          break
        case 'fromEmail':
          state.emailTemplate.fromEmail = data.value
          break
        case 'fromName':
          state.emailTemplate.fromName = data.value
          break
        case 'subject':
          state.emailTemplate.subject = data.value
          break
        case 'html':
          state.emailTemplate.html = data.value
          break
        case 'templateText':
          state.emailTemplate.template = data.value
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/mutations.js